export enum MenuType {
  isWebOrdering = 'Weborder',
  isKiosk = 'Kiosk',
  isParked = 'Parked',
  isDeliveryPartner = 'Delivery Partner',
  isPOS = 'POS',
  isOrderAtTable = 'Order At Table',
  isMobile = 'Mobile',
}
